export default __webpack_public_path__ + "static/media/reduxLogo.b3b939c6.png";